import { AuthProvider, useAuth } from "./lib/AuthContext";
import { COLORS } from "./lib/colors";
import * as Sentry from "@sentry/react";
import LoginPage from "./components/LoginPage";
import AppShell from "./components/AppShell";

function AppRouter() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
        backgroundColor: COLORS.bg, minHeight: "100vh",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12, backgroundColor: COLORS.accent,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontWeight: 700, fontSize: 22, marginBottom: 16,
          }}>E</div>
          <p style={{ color: COLORS.textMuted, fontSize: 14 }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <AppShell />;
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 40 }}>Something went wrong.</p>}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
